'use strict';

var StoreService = {
  slugify: function slugify(str) {
    return (str || '')
      .toLowerCase()
      .replace(/[\u00C0-\u00C5]/gi, 'a')
      .replace(/[\u00E7]/gi, 'c')
      .replace(/[\u00C8-\u00CB]/gi, 'e')
      .replace(/[\u00CC-\u00CF]/gi, 'i')
      .replace(/[\u00D2-\u00D6]/gi, 'o')
      .replace(/[\u00D9-\u00DC]/gi, 'u')
      .replace(/[\u00D1]/gi, 'n')
      .replace(/[^a-z0-9\s]+/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[-]{2,}/g, '')
      .replace(/[^a-z\-\s]*/gi, '');
  },

  debounce: function debounce(wait, func, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },

  throttle: function throttle(wait, func) {
    var args = arguments;
    var time = Date.now();
    return function () {
      if (time + wait - Date.now() < 0) {
        func.apply(this, args);
        time = Date.now();
      }
    }.bind(this);
  }
};

module.exports = StoreService;
